import { useState } from "@wordpress/element";
import { Icon, Spinner } from "@wordpress/components";
import { svgSearch } from "../shared/svg/search";

export default function FAQsSection({ faqsList, sectionTitle, phrases }) {
	const [activeTab, setActiveTab] = useState(0);
	const [searchQuery, setSearchQuery] = useState("");
	const [isSearching, setIsSearching] = useState(false);

	const handleSearch = (e) => {
		e.preventDefault();
		setIsSearching(true);
		// Simulate API call or search operation
		setTimeout(() => {
			setIsSearching(false);
		}, 1000);
	};

	const filteredFAQs = isSearching
		? []
		: faqsList.filter(
				(faq) =>
					faq.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
					faq.content.toLowerCase().includes(searchQuery.toLowerCase()),
		  );

	const handleActiveTab = (index) => {
		setActiveTab(activeTab === index ? null : index);
	};

	return (<section className="mx-4 mb-16">
			<h3 className="text-xl font-bold pe-5 text-start lg:text-center lg:text-3xl text-body">{sectionTitle}</h3>
			<form onSubmit={(e) => handleSearch(e)}
				  className="relative flex flex-col justify-start w-full mx-auto mt-6 mb-8 transition-all bg-white shadow rounded-xl">
				<input
					type="search"
					placeholder={phrases.search}
					className="w-full h-full p-4 border rounded-lg shadow-sm border-semiGray ps-10 focus:outline-none focus:border-body focus:ring-body"
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
				/>
				<button
					type="submit"
					className="absolute cursor-pointer ltr:left-3 rtl:right-3 top-4"
					aria-label="Button"
				>
					<Icon icon={svgSearch}/>
				</button>
			</form>


			{isSearching ? (<div className="flex items-center justify-center w-full my-8">
					<Spinner
						style={{
							height: "calc(2px * 20)",
							width: "calc(2px * 20)",
						}}
					/>
				</div>) : filteredFAQs.length === 0 ? (<div className="py-8 text-center">
					<p className="text-lg text-gray-600">
						{phrases.no_faq}
					</p>
				</div>) : (<div id="faqs">
					{filteredFAQs.map((item, index) => {
						const firstItem = index === 0;
						const lastItem  = index === faqsList.length - 1;
						const isActive  = activeTab === index;
						return (<a
								className={`block w-full px-8 py-8 2xl:py-10 ${isActive ? "bg-lightGray" : "bg-white"} rounded-2xl`}
								key={index}
								onClick={() => {
									handleActiveTab(index);
								}}
							>
								<div className="flex items-center justify-between cursor-pointer mb-7">
									<span className="font-bold">{item.title} </span>
									<svg
										width="34"
										height="34"
										viewBox="0 0 34 34"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										className={`transform ${isActive ? "rotate-180" : ""} transition-transform`}
									>
										<path
											d="M26.9164 22.3128C26.6444 22.3128 26.3724 22.2094 26.1656 22.0011L16.9998 12.8353L7.83398 22.0011C7.41889 22.4162 6.74593 22.4162 6.33084 22.0011C5.91576 21.586 5.91576 20.9131 6.33084 20.498L16.2475 10.5813C16.6626 10.1662 17.3356 10.1662 17.7506 10.5813L27.6673 20.498C28.0824 20.9131 28.0824 21.586 27.6673 22.0011C27.4605 22.2094 27.1884 22.3128 26.9164 22.3128Z"
											fill="#2F2F30"
										/>
									</svg>
								</div>
								{isActive && (<p className="w-full font-normal sm:font-medium text-body sm:w-3/4">
										{wp.element.RawHTML({ children: item.content })}
									</p>)}
							</a>);
					})}
				</div>)}
		</section>);
}
